import { recommendedImageSize } from 'src/pages/CommunityDetails/PostModalPublication/components/postModalActions/postModalActions.constants'
import { GetImageDimensionsParams } from './postImage.types'

export const getImageDimensions = ({ mediaWidth, mediaHeight }: GetImageDimensionsParams) => {
  const { width, height } = recommendedImageSize

  if (Number(mediaWidth) > width) {
    return {
      width,
      height
    }
  }

  return {
    width: mediaWidth,
    height: mediaHeight
  }
}
